import React, { Component } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { CheckCircle2, Lock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <SectionWrapper bgColor="cream" data-id="element-79">
      <div className="text-center mb-6" data-id="element-80">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-4 leading-tight" data-id="element-81">
          Tu Cuerpo Lleva Meses Pidiéndote Ayuda. Hoy Puedes Responderle.
        </h2>

        <p className="font-sans text-lg text-gray-700 mb-5 max-w-xl mx-auto" data-id="element-82">
          Por solo $6.39 dólares — menos de lo que cuesta un café con leche —
          tienes en tus manos el sistema completo para:
        </p>
      </div>

      <div className="bg-white rounded-3xl p-6 shadow-md border border-accent/20 mb-6" data-id="element-83">
        <ul className="space-y-3 mb-6 max-w-md mx-auto" data-id="element-84">
          <li className="flex items-center gap-3" data-id="element-85">
            <div className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center shrink-0" data-id="element-86">
              <div className="w-3 h-3 rounded-full bg-accent" data-id="element-87"></div>
            </div>
            <span className="font-medium text-gray-800 text-lg" data-id="element-88">
              Resetear tu hígado desde adentro
            </span>
          </li>
          <li className="flex items-center gap-3" data-id="element-89">
            <div className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center shrink-0" data-id="element-90">
              <div className="w-3 h-3 rounded-full bg-accent" data-id="element-91"></div>
            </div>
            <span className="font-medium text-gray-800 text-lg" data-id="element-92">
              Desinflamar tu vientre visiblemente
            </span>
          </li>
          <li className="flex items-center gap-3" data-id="element-93">
            <div className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center shrink-0" data-id="element-94">
              <div className="w-3 h-3 rounded-full bg-accent" data-id="element-95"></div>
            </div>
            <span className="font-medium text-gray-800 text-lg" data-id="element-96">
              Recuperar la energía que sientes que perdiste
            </span>
          </li>
          <li className="flex items-center gap-3" data-id="element-97">
            <div className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center shrink-0" data-id="element-98">
              <div className="w-3 h-3 rounded-full bg-accent" data-id="element-99"></div>
            </div>
            <span className="font-medium text-gray-800 text-lg" data-id="element-100">
              Volver a sentirte bien en tu propio cuerpo
            </span>
          </li>
        </ul>

        <p className="text-center font-serif text-xl italic text-primary mb-6" data-id="element-101">
          No más ensayos y errores. No más dietas que fallan. No más mañanas
          pesadas.
        </p>

        <div className="max-w-md mx-auto" data-id="element-102">
          <CTAButton className="py-5 text-xl" data-id="element-103" />

          <div className="mt-4 space-y-2" data-id="element-104">
            <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-105">
              <CheckCircle2 className="w-4 h-4 text-success" data-id="element-106" /> Acceso
              Instantáneo
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-107">
              <CheckCircle2 className="w-4 h-4 text-success" data-id="element-108" /> Garantía 14 Días
              Sin Riesgo
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-109">
              <CheckCircle2 className="w-4 h-4 text-success" data-id="element-110" /> Precio Especial
              de Lanzamiento: $6.39
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-111">
              <CheckCircle2 className="w-4 h-4 text-success" data-id="element-112" /> 4 Componentes
              Incluidos
            </div>
          </div>

          <div className="mt-5 pt-4 border-t border-gray-100 flex flex-col items-center gap-2" data-id="element-113">
            <div className="flex items-center gap-2 text-gray-500 text-sm font-medium" data-id="element-114">
              <Lock className="w-4 h-4" data-id="element-115" /> Checkout 100% Seguro por Hotmart
            </div>
            <div className="flex items-center gap-4 text-gray-400" data-id="element-116">
              <CreditCard className="w-6 h-6" data-id="element-117" />
              <span className="text-xs font-bold tracking-wider" data-id="element-118">
                VISA | MASTERCARD | PAYPAL | PIX | AMEX
              </span>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center font-serif text-2xl md:text-3xl font-bold text-primary italic" data-id="element-119">
        "14 días para resetear lo que años de dietas no pudieron."
      </p>
    </SectionWrapper>;
}